// @flow

import { connect } from 'react-redux';
import type { ComponentType } from 'react';
import StyledColumn from './column.styled';
import { getUiSetting } from '../../store/uiStore';
import type { Props as StyledColumnProps } from './column.styled';

type StateProps = {|
  slidersEnabled: boolean,
|};

const mapStateToProps = (state): StateProps => ({
  slidersEnabled: getUiSetting(state, 'slidersEnabled'),
});

const ColumnContainer: ComponentType<$Diff<StyledColumnProps, StateProps>> = connect(
  mapStateToProps,
)(StyledColumn);

export default ColumnContainer;
